<!-- 采购退补数据操作 -->
<template>
    <div v-if="isLoad">
        <purchaseListOrderTemplate ref="purchaseListOrderTemplate"></purchaseListOrderTemplate>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="100px" id="mainInfo" class="baseForm" ref="sendDataInfo" :model="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType!=2" ref="mainRow">
                                            <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                                          :rules="formOneValue.isRequired == 1 && formOneValue.isChange == 1 ? [{required: true, trigger: ['blur', 'change']}] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 退货单位 -->
                                                <el-tooltip v-if="formOneValue.fieldType == 'extract'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField,formOneValue.nosetField)"
                                                              :disabled="formOneValue.isChange==0 || dataActionBox.actionType == 1">
                                                        <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField,formOneValue.nosetField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange==0 || dataActionBox.actionType == 1">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
                                                              :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 2">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 2">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <df-date class="form_codition" :isdisabled="formOneValue.isChange == 0" :isShowLong="false" @keyup.enter.native="nextFocus(formOneKey)" :ref="formOneValue.entityField"
                                                         :id="formOneValue.entityField" v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                <el-input :disabled="formOneValue.isChange == 0" v-else v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneKey)"
                                                          :ref="formOneValue.entityField" :id="formOneValue.entityField">
                                                </el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType==2">
                                            <el-form-item :label="formOneValue.showField+':'" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                                <span v-if="formOneValue.fieldType == 'date'">{{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}</span>
                                                <span v-else-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                                                </span>
                                                <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <el-form size="mini" v-if="sendDataInfo.detailAdds">
                                        <div id="operateBtn" v-if="dataActionBox.actionType!=2">
                                            <el-button type="primary" size="mini" @click="deleteDetails()">删除</el-button>
                                        </div>
                                        <el-table size="mini" ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange"
                                                  :data="sendDataInfo.detailAdds" :height="mxHeight" border style="width: 100%">
                                            <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType!=2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <template v-for="(formOneValue,formOneKey) in mxForm">
                                                <el-table-column align="center" :min-width="formOneValue.fieldWeight" :prop="formOneValue.entityField" show-overflow-tooltip :label="formOneValue.showField"
                                                                 :key="formOneKey" v-if="formOneValue.isShow==1">
                                                    <template slot-scope="scope">
                                                        <!-- 生产日期 -->
                                                        <span v-if="formOneValue.fieldType == 'date'">
                                                            {{sendDataInfo.detailAdds[scope.$index][formOneValue.entityField]?$common.getLocalTime(sendDataInfo.detailAdds[scope.$index][formOneValue.entityField]):''}}
                                                        </span>
                                                        <span v-else-if="formOneValue.isRift == 1">
                                                            <a @click="toDetail(sendDataInfo.detailAdds[scope.$index][formOneValue.riftField])">
                                                                {{sendDataInfo.detailAdds[scope.$index][formOneValue.entityField]}}</a>
                                                        </span>
                                                        <!-- 退补数量 -->
                                                        <el-input @input="calculatePrice(5,scope.$index)" :ref="formOneValue.entityField" @change="checkNumber(scope.$index)"
                                                                  @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)"
                                                                  v-else-if="formOneValue.entityField == 'refundNum' && dataActionBox.actionType!=2&&formOneValue.isChange==1"
                                                                  v-model="sendDataInfo.detailAdds[scope.$index][formOneValue.entityField]" type="number" min="0"></el-input>
                                                        <!-- 退补价 -->
                                                        <el-input @input="calculatePrice(2,scope.$index)" :ref="formOneValue.entityField" @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)"
                                                                  v-else-if="formOneValue.entityField == 'rrdPsprice' && dataActionBox.actionType!=2&&formOneValue.isChange==1"
                                                                  v-model="sendDataInfo.detailAdds[scope.$index][formOneValue.entityField]" type="number" min="0"></el-input>
                                                        <!-- 退补金额 -->
                                                        <el-input @input="calculatePrice(4,scope.$index)" :ref="formOneValue.entityField" @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)"
                                                                  v-else-if="formOneValue.entityField == 'rrdPsmoney' && dataActionBox.actionType!=2&&formOneValue.isChange==1"
                                                                  v-model="sendDataInfo.detailAdds[scope.$index][formOneValue.entityField]" type="number" min="0"></el-input>
                                                        <!-- 新价格 -->
                                                        <el-input @input="calculatePriceNew(4,scope.$index)" :ref="formOneValue.entityField" @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)"
                                                                  v-else-if="formOneValue.entityField == 'newPrice' && dataActionBox.actionType!=2&&formOneValue.isChange==1"
                                                                  v-model="sendDataInfo.detailAdds[scope.$index][formOneValue.entityField]" type="number" min="0"></el-input>
                                                        <span v-else>
                                                            {{sendDataInfo.detailAdds[scope.$index][formOneValue.entityField]}}
                                                        </span>
                                                    </template>
                                                </el-table-column>
                                            </template>

                                        </el-table>

                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val)=>{mxHeight=val}"></tree>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="addProductFun" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <ExtractionScheme ref="extractionScheme" :psbkmId="sendDataInfo.psbkmId" :ppId="ppId" :id="exId" @TranData="getExData" @getWidth="getExWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
import purchaseListOrderTemplate from "@/components/purchaseListOrderTemplate.vue";
export default {
    name: "purchaseRefundAction",
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: { ExtractionScheme, SearchScheme, purchaseListOrderTemplate },
    data() {
        //这里存放数据
        return {
            ppId: "",
            selectedDetailsIndex: 0,
            exTitle: "",
            exWidth: "90%",
            exId: "",
            smId: "",
            DialogVisible: false,
            DialogExtract: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            mxHeight: 0,
            tabForm: [], // 主表单
            mxForm: [], //明细表单
            footForm: [], // 表尾
            sField: '', // 赋值字段
            fField: '', //焦点字段
            nosField: '', // 不可赋值字段
            inputel: '', //所有input对象
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            seType: "",
            seIndex: 0,
            seWidth: '',
            parentSearchData: {},
            selectedRow: [], // 当前已选择行
            isLoad: false
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.detailAdds": {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.totalMoney = 0;
                this.sendDataInfo.totalNumber = 0;
                this.sendDataInfo.totalCount = 0;
                newValue.forEach((item, keys) => {
                    //   var thisTotalPrice = this.$common.getDecimalInfo(
                    //     3,
                    //     NP.times(parseFloat(item.refundNum), parseFloat(item.rrdPsprice))
                    //   );
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                        3,
                        NP.plus(this.sendDataInfo.totalMoney, parseFloat(item.rrdPsmoney))
                    );
                    this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
                        1,
                        NP.plus(
                            parseFloat(this.sendDataInfo.totalNumber),
                            parseFloat(item.refundNum)
                        )
                    );
                    // 计算含税金额 含税价格*数量
                    this.sendDataInfo.detailAdds[keys].psmoney =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(item.psprice, item.refundNum)
                        );
                });
                if (isNaN(this.sendDataInfo.totalMoney)) {
                    this.sendDataInfo.totalMoney = 0;
                }
                this.sendDataInfo.totalCount = this.sendDataInfo.detailAdds.length;
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        tabHeight(val) {
            this.mxHeight = val
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, nosField) {
            removeEventListener('keyup', this.keyUp)
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.fField = fField
            this.nosField = nosField
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            this.$nextTick(() => {
                this.nextFocus(this.seIndex)
            })
        },
        changeInputModel(val) {
            // debuggger
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                addEventListener('keyup', this.keyUp)//创建监听键盘事件
                this.paramValue(val)
            }
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) {
                if (this.sendDataInfo.detailAdds.length > 0) this.tableNextFocus('rrdPsprice', this.selectedDetailsIndex)
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }

            this.inputel[aindex].focus()
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            if (!field) return
            if (field == 'keydown') {
                if (index == this.sendDataInfo.detailAdds.length - 1) return
                if (this.sendDataInfo.detailAdds[index + 1] != undefined) {
                    this.$refs['rrdPsprice'][index + 1].focus() //跳退货数量
                    this.selectedDetailsIndex = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.detailAdds[this.selectedDetailsIndex]);
                    })
                    return
                }
            }
            this.$refs[field][index].focus()
        },
        // 初始化焦点
        initFocus() {
            console.log('初始化焦点')
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == 'F1') { // 右键新增明细
                e.preventDefault();
                // this.addDetail('sendDataInfo')
                return
            } else if (e.key == 'F2') {
                e.preventDefault();
                this.deleteDetails()
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.sendDataInfo.detailAdds.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == this.sendDataInfo.detailAdds.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0
                    } else { // 正常递增
                        this.selectedDetailsIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.detailAdds[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.detailAdds[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.sendDataInfo.detailAdds.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex = this.sendDataInfo.detailAdds.length - 1
                    } else { // 正常递减
                        this.selectedDetailsIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.detailAdds[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.detailAdds[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            }

        },
        closeChild() {
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {}
            this.selectedDetailsIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
            } else {
                return
            }
        },
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        deleteDetails(index) {
            if (this.sendDataInfo.detailAdds.length > 0) {
                if (this.selectedDetailsIndex === "") {
                    return this.$message({
                        message: "请先选中明细",
                        type: "warning",
                    });
                } else {
                    this.sendDataInfo.detailAdds.splice(this.selectedDetailsIndex, 1);
                    if (this.sendDataInfo.detailAdds.length > 1) {
                        this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
                        console.log(this.selectedDetailsIndex)
                    } else {
                        this.selectedDetailsIndex = 0
                    }
                    this.tableNextFocus('rrdPsprice', this.selectedDetailsIndex)
                    let refsElTable = this.$refs.mxTableRef
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.detailAdds[this.selectedDetailsIndex]);
                }
            } else {
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
            }
        },
        // 触发提取方案
        openExComponents(e, index) {
            removeEventListener('keyup', this.keyUp)
            this.exId = e;
            this.seIndex = index
            this.DialogExtract = true;
        },
        // 获取 提取单数据
        async getExData(val) {
            console.log(val);
            this.sendDataInfo.detailAdds = []
            for (let key in val) {
                if (key == "arrlistbychen") {
                    for (const key1 in val.arrlistbychen) {
                        this.$set(this.sendDataInfo.detailAdds, key1, val.arrlistbychen[key1])
                        this.mxForm.forEach(item => {
                            if (item.fieldType == 'search' && item.setField) {
                                var arr = item.setField.split(',')
                                arr.forEach(item2 => {
                                    this.$set(this.sendDataInfo.detailAdds[key1], item2, val.arrlistbychen[key1][item2])
                                })
                            } else {
                                this.$set(this.sendDataInfo.detailAdds[key1], item.entityField, val.arrlistbychen[key1][item.entityField])
                            }
                        })
                    }
                } else {
                    this.sendDataInfo[key] = val[key];
                }
            }
            this.sendDataInfo.detailAdds.forEach((item) => {
                item.rrdPrice = 0;
                item.rrdMoney = 0;
            });
            this.DialogExtract = false;
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
            this.$nextTick(() => {
                this.selectedDetailsIndex = 0
                let refsElTable = this.$refs.mxTableRef
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(this.sendDataInfo.detailAdds[this.selectedDetailsIndex]);
                this.nextFocus(this.seIndex)
            })
        },
        getExWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        handleDrawerClose(done) {
            this.$confirm("确认关闭？")
                .then((_) => {
                    done();
                })
                .catch((_) => { });
        },
        resetForm(formName) {
            this.init();
            this.$refs[formName].resetFields();
        },
        addProductFun(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(valid);
                    this.sendDataAction();
                } else {
                    return false;
                }
            });
        },
        checkNumber(index) {
            var info = this.sendDataInfo.detailAdds[index];
            if (info.oldNum > 0) {
                if (info.refundNum > info.oldNum) {
                    this.sendDataInfo.detailAdds[index].refundNum = info.oldNum;
                    this.$message({
                        message: "退补数量不能大于原单数量",
                        type: "warning",
                    });
                } else if (info.refundNum <= 0) {
                    this.sendDataInfo.detailAdds[index].refundNum = info.oldNum;
                    this.$message({
                        message: "退补数量不能小于或等于0",
                        type: "warning",
                    });
                }
            } else {
                if (info.refundNum < info.oldNum) {
                    this.sendDataInfo.detailAdds[index].refundNum = info.oldNum;
                    this.$message({
                        message: "退补数量不能小于原单数量",
                        type: "warning",
                    });
                } else if (info.refundNum >= 0) {
                    this.sendDataInfo.detailAdds[index].refundNum = info.oldNum;
                    this.$message({
                        message: "退补数量不能大于或等于0",
                        type: "warning",
                    });
                }
            }
            this.calculatePrice(5, index)
        },
        // 计算价格

        calculatePrice(cate = 1, index) {
            var info = this.sendDataInfo.detailAdds[index];
            // 缓存常用变量，避免重复访问
            const details = this.sendDataInfo.detailAdds[index];
            switch (cate) {
                case 2: // 通过含税价格计算全部
                    // 计算含税金额 含税价格*数量
                    details.rrdPsmoney = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.rrdPsprice, info.refundNum));
                    // 计算金额 含税金额/(税率/100+1)
                    var midmoney = this.$common.getDecimalInfo(3, NP.divide(details.rrdPsmoney, NP.plus(NP.divide(info.inRate, 100), 1)))
                    details.rrdMoney = this.$common.getDecimalInfo(3, midmoney);
                    // 计算单价 金额/数量
                    details.rrdPrice = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.refundNum));

                    // 新含税价 退补价+原含税价
                    details.newPrice = this.$common.getDecimalInfo(2, NP.plus(info.psprice, info.rrdPsprice));
                    break;
                case 4: // 通过含税金额计算全部
                    // 计算含税价格  含税金额 / 数量
                    details.rrdPsprice = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(info.rrdPsmoney, info.refundNum));
                    // 计算总金额 含税金额/(税率/100+1)
                    var midmoney = this.$common.getDecimalInfo(3, NP.divide(info.rrdPsmoney, NP.plus(NP.divide(info.inRate, 100), 1)))
                    // var midmoney = NP.divide(info.rrdPsmoney, NP.plus(NP.divide(info.inRate, 100), 1)).toFixed(10)
                    details.rrdMoney = this.$common.getDecimalInfo(3, midmoney);
                    // 计算单价 金额/数量
                    details.rrdPrice = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.refundNum));
                    // 新含税价 退补价+原含税价
                    details.newPrice = this.$common.getDecimalInfo(2, NP.plus(info.psprice, details.rrdPsprice));
                    break;
                default://通过数量计算
                    // 计算含税金额 含税价格*数量
                    var moneyOne = this.$common.getDecimalInfo(3, NP.times(info.rrdPsprice ? info.rrdPsprice : 0, info.refundNum));
                    details.rrdPsmoney = moneyOne;
                    var midmoney = this.$common.getDecimalInfo(3, NP.divide(info.rrdPsmoney, NP.plus(NP.divide(info.inRate, 100), 1)))
                    details.rrdMoney = this.$common.getDecimalInfo(3, midmoney);
                    // 计算单价 金额/数量
                    details.rrdPrice = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.refundNum));
                    // 新含税价 退补价+原含税价
                    details.newPrice = this.$common.getDecimalInfo(2, NP.plus(info.psprice, details.rrdPsprice));
                    break;
            }
        },
        calculatePriceNew(cate = 1, index) {
            var info = this.sendDataInfo.detailAdds[index];
            //退补含税价=新含税价-原含税价
            this.sendDataInfo.detailAdds[index].rrdPsprice = this.$common.getDecimalInfo(2, NP.minus(info.newPrice, info.psprice))
            //退补含税金额=退补含税价*数量
            var moneyOne = this.$common.getDecimalInfo(3, NP.times(info.rrdPsprice ? info.rrdPsprice : 0, info.refundNum));
            this.sendDataInfo.detailAdds[index].rrdPsmoney = moneyOne;
            // 计算总金额 含税金额/(税率/100+1)
            var midmoney = this.$common.getDecimalInfo(3, NP.divide(info.rrdPsmoney, NP.plus(NP.divide(info.inRate, 100), 1)))
            this.sendDataInfo.detailAdds[index].rrdMoney = this.$common.getDecimalInfo(3, midmoney);
            this.sendDataInfo.detailAdds[index].rrdPrice = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.refundNum));
        },
        // 提取采购记账单
        async extractData(data) {
            if (data.length >= 1) {
                var sendData = [];
                data.forEach((items) => {
                    sendData.push(items.psbkdId);
                });
                let responseData = await this.$http.extractPurchaseReimbursement({
                    ids: sendData,
                });
                if (responseData.status == 200) {
                    this.sendDataInfo = responseData.result;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }
        },
        initActionBox() {
            this.$confirm("确定取消新增吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$common.delOrderInfo(this.sendDataInfo.psbkmId)
                    this.init();
                    this.dataActionBox.actionType = 0;
                    this.$emit('drawerCancel')
                })
                .catch(() => {
                });

        },
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.detailAdds = [];
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.filterMainField()
            this.showTabs = this.actionData.formData[0].jciName
            this.init();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.sendDataInfo.rrmRapdate = this.$moment().valueOf();
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                this.sendDataInfo = oldData;
            } else {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.$refs['tree'].init(this.sendDataInfo.rrmId)
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 16.7)
            })


        },
        async sendDataAction() {
            if (!this.sendDataInfo.psbkmId) {
                this.$message({
                    message: "请先提取记账单",
                    type: "error",
                });
                return false;
            }
            if (this.sendDataInfo.detailAdds.some((val) => val.rrdPrice == 0 || val.rrdPrice == '')) {
                return this.$message({
                    message: "退补价不能为零或者空",
                    type: "error",
                });
            }
            if (this.sendDataInfo.detailAdds.some((val) => val.rrdMoney == 0 || val.rrdMoney == '')) {
                return this.$message({
                    message: "退补金额不能为零或者空",
                    type: "error",
                });
            }
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addPurchaseReimbursement(sendData);
            } else {
                var responseData = await this.$http.setPurchaseReimbursement(sendData);
            }
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit('drawerCancel')
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
                }
            })
            var arr = [{ entityField: "detailAdds" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.$nextTick(() => {
                this.isLoad = true
            })
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.ppId = "psbkmId";
        this.$nextTick(() => {
            this.openBox()
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        addEventListener('keyup', this.keyUp)//创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUp)
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {

        this.getMainInput()
    }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.formbot {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.newInput {
    height: 20px;
    line-height: 20px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 28px;
    line-height: 28px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}

.mb {
    margin-bottom: 0;
}
</style>